module.exports = __webpack_public_path__ + "static/media/cpo-default.e4b99970.png";